var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComponentsOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "components",
    transform: "translate(-3.15 -3.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43911",
    "data-name": "Path 43911",
    d: "M11.636,7.288,15.774,3.15l4.137,4.138-4.137,4.138Zm2.759,0L15.774,5.91l1.379,1.379L15.774,8.667,14.395,7.288Z",
    transform: "translate(-3.123)",
    fill: "#505f7b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43912",
    "data-name": "Path 43912",
    d: "M3.15,15.773l4.138-4.138,4.138,4.138L7.288,19.91Zm2.759,0,1.379-1.379,1.379,1.379L7.288,17.152,5.91,15.773Z",
    transform: "translate(0 -3.123)",
    fill: "#505f7b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43913",
    "data-name": "Path 43913",
    d: "M20.121,15.773l4.138,4.137L28.4,15.773l-4.137-4.138Zm4.138-1.379-1.38,1.379,1.379,1.379,1.378-1.379-1.379-1.379Z",
    transform: "translate(-6.246 -3.123)",
    fill: "#505f7b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43914",
    "data-name": "Path 43914",
    d: "M11.636,24.259l4.138-4.138,4.137,4.138L15.773,28.4l-4.138-4.137Zm2.759,0,1.378-1.38,1.379,1.379-1.379,1.378-1.379-1.379Z",
    transform: "translate(-3.123 -6.246)",
    fill: "#505f7b",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponentsOutline);
export default __webpack_public_path__ + "static/media/componentsOutline.b2cea61f.svg";
export { ForwardRef as ReactComponent };